export default function PHP_ob_get_length() {
  return (
    <div>
      <h1>PHP_ob_get_length</h1>
    </div>
  );
}
